import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";

import { GridFilterTag } from "@hermes/states/grid-filters-state";

@Component({
    selector: "h-grid-filters-tag",
    templateUrl: "./grid-filters-tag.component.html",
    styleUrls: ["./grid-filters-tag.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFiltersTagComponent {
    @Input()
    public gridFilterTag: GridFilterTag;

    @Output()
    public remove = new EventEmitter<GridFilterTag>();
}
